import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as UserService from '_services/user-service';

// 
const initialState = {
    airportInformation: null,
    status: 'idle',
    error: null,
};

// post new information
export const postAirportInformation = createAsyncThunk('airportInformation/postAirportInformation', async (information) => {
    return UserService.postFeedback(information);
});


const airportInformationSlice = createSlice({
    name: 'airportInformation',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [postAirportInformation.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [postAirportInformation.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
            }
        },
        [postAirportInformation.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        }
    }
});

export const { reset } = airportInformationSlice.actions;
export const selectAirportInformation = state => state.airportInformation.airportInformation;
export const selectAirportInformationStatus = state => state.airportInformation.status;
export default airportInformationSlice.reducer;
